import { Route } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { TiendaLayoutComponent } from './layout/tienda-layout/tienda-layout.component';
import { validateAuthGuard } from './core/guards/validate-auth.guard'; // Importa el guard
import { isLoggedGuard } from './core/guards/is-logged.guard';

export const routes: Route[] = [
  // ADMIN ROUTES (protegidas con el guard de autenticación)
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [validateAuthGuard], // Aplica el guard de autenticación
    children: [
      {
        path: 'nuevo-socio',
        title: 'Nuevo Socio',
        loadChildren: () =>
          import('./pages/nuevo-socio/nuevo-socio.module').then(
            (c) => c.NuevoSocioModule
          ),
      },
      {
        path: 'ajustes',
        title: 'Ajustes',
        loadChildren: () =>
          import('./pages/ajustes/ajustes.module').then((c) => c.AjustesModule),
      },
      {
        path: 'parametros',
        title: 'Gestión de Parámetros',
        loadChildren: () =>
          import('./pages/gestion-parametros/gestion-parametros.module').then((c) => c.GestionParametrosModule),
      },
      {
        path: 'home',
        title: 'La Soberanía de Seguros',
        loadChildren: () =>
          import('./pages/home/home.module').then((c) => c.HomeModule),
      },
      {
        path: 'administrar-tienda',
        title: 'Administrar Tienda',
        loadChildren: () =>
          import('./pages/administrar-tienda/administrar-tienda.module').then((c) => c.AdministrarTiendaModule)
      },
      {
        path: 'contratos-global',
        title: 'Contratos Global',
        loadChildren: () =>
          import('./pages/contratos-global/contratos-global.module').then((c) => c.ContratosGlobalModule)
      }
    ],
  },

  {
    path: 'account',
    component: AdminLayoutComponent,
    canActivate: [validateAuthGuard], // Aplica el guard de autenticación
    children: [
      {
        path: 'profile',
        title: 'Mi Cuenta',
        loadChildren: () =>
          import('./pages/administrar-perfil/administrar-perfil.module').then(
            (c) => c.AdministrarPerfilModule
          ),
      },
    ],
  },
  // TIENDA ROUTES (protegidas con el guard de autenticación)
  {
    path: ':idTienda',
    component: TiendaLayoutComponent,
    canActivate: [validateAuthGuard], // Aplica el guard de autenticación
    children: [
      // Marcador viejo de la pantalla retirada Nuevo contrato (en los logs aparecen
      // cargas de /<tienda>/contratos/nuevo-contrato, que caía al login). Lleva a
      // Nueva solicitud, igual que /<tienda>/seguros/nuevo-contrato.
      {
        path: 'contratos/nuevo-contrato',
        redirectTo: 'seguros/nueva-solicitud',
        pathMatch: 'full'
      },
      {
        path: 'seguros',
        title: 'Seguros',
        loadChildren: () =>
          import('./pages/contratos/seguros.module').then(
            (c) => c.SegurosModule
          ),
      },
      {
        path: 'siniestros',
        title: 'Siniestros',
        loadChildren: () =>
          import('./pages/siniestros/siniestros.module').then(
            (c) => c.SiniestrosModule
          ),
      },
      {
        path: 'cierres',
        title: 'Cierres',
        loadChildren: () =>
          import('./pages/cierres-comisiones/cierres-comisiones.module').then(
            (c) => c.CierresComisionesModule
          ),
      },
      {
        path: 'contactos',
  title: 'Clientes',
        loadChildren: () =>
          import('./pages/contactos/contactos.module').then((c) => c.ContactosModule),
      },
      {
        path: 'vehiculos',
        title: 'Vehículos',
        loadChildren: () =>
          import('./pages/vehiculos/vehiculos.module').then((c) => c.VehiculosModule),
      },
      {
        path: 'dashboard',
        title: 'Inicio',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then(
            (c) => c.DashboardModule
          ),
      },
      {
        path: 'usuarios',
        title: 'Usuarios',
        loadChildren: () =>
          import('./pages/usuarios-tienda/usuarios-tienda.module').then((c) => c.UsuariosTiendaModule),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/auth/login'
      }
    ],
  },
  // AUTH ROUTES (sin guard, accesibles a usuarios no autenticados)
  {
    path: 'auth',
    title: 'Login',
    canActivate: [isLoggedGuard],
    loadChildren: () =>
      import('./pages/auth/auth.module').then((c) => c.AuthModule),
  },
  {
    path: 'rcv',
    title: 'Validar Poliza',
    loadChildren: () =>
      import('./pages/rcv/rcv.module').then((c) => c.RcvModule),
  },
  // DEFAULT ROUTE
  {
    path: '**',
    redirectTo: 'auth/login', // Redirige a la autenticación si no encuentra la ruta
  },
];
